import { useProductTaxonomy } from '@/services/product-taxonomy';

/** The taxonomy terms the integrations catalog + synthesized descriptions embed. */
export type IntegrationTaxonomyTerms = {
  customersPlural: string;
  customerSingular: string;
  campaignsPlural: string;
  peoplePlural: string;
};

/** Resolve the taxonomy terms the integrations list needs, via the product-taxonomy service. */
export function useProductTaxonomyTerms(): IntegrationTaxonomyTerms {
  const taxonomy = useProductTaxonomy();
  return {
    customersPlural: taxonomy.term('customers.plural'),
    customerSingular: taxonomy.term('customers.singular'),
    campaignsPlural: taxonomy.term('campaigns.plural'),
    peoplePlural: taxonomy.term('people.plural'),
  };
}
